import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-054a2ca4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "but_table_cancelbet",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  width: "110",
  height: "40",
  viewBox: "0 0 110 40",
  class: "svg"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<defs data-v-054a2ca4><linearGradient id=\"confirm-linear-gradient\" x1=\"0.5\" x2=\"0.5\" y2=\"1\" gradientUnits=\"objectBoundingBox\" data-v-054a2ca4><stop offset=\"0\" stop-color=\"#60ec77\" data-v-054a2ca4></stop><stop offset=\"1\" stop-color=\"#25a63b\" data-v-054a2ca4></stop></linearGradient><linearGradient id=\"confirm-linear-gradient-2\" x1=\"0.5\" x2=\"0.5\" y2=\"1\" gradientUnits=\"objectBoundingBox\" data-v-054a2ca4><stop offset=\"0\" stop-color=\"#b9ffc5\" data-v-054a2ca4></stop><stop offset=\"1\" stop-color=\"#2c8a3c\" data-v-054a2ca4></stop></linearGradient></defs><g id=\"but_more\" data-v-054a2ca4><rect id=\"Rectangle_45\" data-name=\"Rectangle 45\" width=\"110\" height=\"40\" rx=\"5\" fill=\"url(#confirm-linear-gradient)\" data-v-054a2ca4></rect><path id=\"矩形_46\" data-name=\"矩形 46\" d=\"M5,1A4,4,0,0,0,1,5V35a4,4,0,0,0,4,4H105a4,4,0,0,0,4-4V5a4,4,0,0,0-4-4H5M5,0H105a5,5,0,0,1,5,5V35a5,5,0,0,1-5,5H5a5,5,0,0,1-5-5V5A5,5,0,0,1,5,0Z\" fill=\"url(#confirm-linear-gradient-2)\" data-v-054a2ca4></path></g>", 2)
const _hoisted_4 = {
  id: "確定投注",
  transform: "translate(33 26)",
  fill: "#fff",
  "font-size": "16",
  "font-family": "PingFangSC-Regular, PingFang SC"
}
const _hoisted_5 = {
  x: "0",
  y: "0"
}
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<g id=\"icon_table_confirm\" transform=\"translate(10 11)\" data-v-054a2ca4><g id=\"Ellipse_22\" data-name=\"Ellipse 22\" fill=\"none\" stroke=\"#fff\" stroke-width=\"1\" data-v-054a2ca4><circle cx=\"9\" cy=\"9\" r=\"9\" stroke=\"none\" data-v-054a2ca4></circle><circle cx=\"9\" cy=\"9\" r=\"8.5\" fill=\"none\" data-v-054a2ca4></circle></g><path id=\"Path_4\" data-name=\"Path 4\" d=\"M-350.308,117.449l3.231,3.231,6.089-6.089\" transform=\"translate(355 -108)\" fill=\"none\" stroke=\"#fff\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" data-v-054a2ca4></path></g>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("text", _hoisted_4, [
      _createElementVNode("tspan", _hoisted_5, _toDisplayString(_ctx.text), 1)
    ]),
    _hoisted_6
  ]))
}